import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "prose prose-sm max-w-none" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col text-left"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col text-left"
}
const _hoisted_4 = {
  key: 2,
  class: "mt-8 w-full"
}
const _hoisted_5 = { class: "flex flex-wrap justify-center gap-2" }
const _hoisted_6 = { class: "flex justify-between items-start w-full px-1 pt-2 mb-3" }
const _hoisted_7 = { class: "w-full text-center text-sm font-bold tracking-tight text-gray-900" }
const _hoisted_8 = { class: "text-[10px] px-2 text-center w-full leading-tight text-gray-500 font-medium pb-2 mb-2 h-8 flex items-center justify-center" }
const _hoisted_9 = { class: "bg-brand-main text-[10px] py-1 text-center w-full leading-tight text-white font-light" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { presets } from "@/assets/ts/diamondFilters";


export default /*@__PURE__*/_defineComponent({
  __name: 'infoModalStonePresets',
  props: {
    value: { default: null }
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const filteredPresets = computed(() => {
  return presets.filter(preset => preset.filters.type === props.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.value === 'earth')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", { class: "text-black font-light text-sm leading-relaxed max-w-lg" }, " Unsere Experten haben für Sie die besten Kombinationen aus Schliff, Farbe und Reinheit zusammengestellt. Bei natürlichen Diamanten setzen wir ausschließlich auf höchste Qualität: ", -1),
          _createElementVNode("p", { class: "text-black font-light text-sm leading-relaxed mt-4" }, [
            _createTextVNode(" • Höchste Brillanz-Schliffqualität 3x excellent"),
            _createElementVNode("br"),
            _createTextVNode(" • Keine Fluoreszenz"),
            _createElementVNode("br"),
            _createTextVNode(" • Laser-Inscription der Zertifikat-Nummer"),
            _createElementVNode("br"),
            _createTextVNode(" • Mit GIA Zertifikat"),
            _createElementVNode("br"),
            _createTextVNode(" • Echte Wertanlage, geprüfte Qualität"),
            _createElementVNode("br"),
            _createTextVNode(" • Alle Diamanten sofort verfügbar ")
          ], -1)
        ]))]))
      : (__props.value === 'lab')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("p", { class: "text-black font-light text-sm leading-relaxed max-w-lg" }, " Unsere Experten haben für Sie die besten Kombinationen aus Schliff, Farbe und Reinheit zusammengestellt. Bei Labordiamanten setzen wir ausschließlich auf höchste Qualität: ", -1),
            _createElementVNode("p", { class: "text-black font-light text-sm leading-relaxed mt-4" }, [
              _createTextVNode(" • Höchste Brillanz-Schliffqualität 3x excellent"),
              _createElementVNode("br"),
              _createTextVNode(" • Keine Fluoreszenz"),
              _createElementVNode("br"),
              _createTextVNode(" • Laser-Inscription der Zertifikat-Nummer"),
              _createElementVNode("br"),
              _createTextVNode(" • Mit IGI Zertifikat"),
              _createElementVNode("br"),
              _createTextVNode(" • Geprüfte Qualität"),
              _createElementVNode("br"),
              _createTextVNode(" • Alle Diamanten sofort verfügbar ")
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
    (filteredPresets.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "text-xl font-bold mb-6 text-gray-900" }, "Unsere Empfehlungen", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPresets.value, (preset) => {
              return (_openBlock(), _createElementBlock("div", {
                key: preset.qualityKey,
                class: "shrink-0 w-[90px] justify-between flex flex-col items-start p-0 rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('components.diamonds.search.presets.' + preset.qualityKey + '.title')), 1)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('components.diamonds.search.presets.' + preset.qualityKey + '.description')), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('components.diamonds.search.presets.' + preset.qualityKey + '.flag')), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})